import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ProgressWithPercentage from "./ProgressWithPercentage";
import logo from "../../../assets/images/Logo.webp";
export default function AuthCallback() {
  const { t } = useTranslation();
  const [name, setSetName] = useState("");
  // const [flag, setFlag] = useState(null);
  // const [isPhoneNumbur, setIsPhoneNumbur] = useState(true);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const email = params.get("email");
    const username = params.get("name");

    const formattedName = (username || "")
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    const formattedCountry = (params.get("countryName") || "")
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    // const formattedFlag = params.get("flag") === "true";

    if (token) {
      const authUser = {
        status: "success",
        data: {
          email,
          username: formattedName,
          token: `Bearer ${token}`,
        },
      };

      localStorage.setItem("authUser", JSON.stringify(authUser));
    }

    setToken(token);
    setSetName(formattedName);
  }, []);

  useEffect(() => {

    const timer = setTimeout(() => {
      // const authUser = localStorage.getItem("authUser");
      const tokenData = JSON.parse(localStorage.getItem("authUser"));
      const tokenSession = tokenData?.data?.token;
      if (tokenSession) {
        const savedData = localStorage.getItem("bookingFormData");
        // console.log("tokenSession", savedData);
        if (savedData) {
          const { redirectUrl } = JSON.parse(savedData);

          if (redirectUrl) {
            navigate(redirectUrl, { replace: true });
            return;
          }
        }
        // navigate("/my-account/dashboard");
        navigate("/", { replace: true });
      } else {
        navigate("/login");
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, token]);

  // console.log(countryName);
  // console.log(typeof flag);
  // console.log(flag);
  return (
    <div className="relative flex items-center justify-center h-screen z-[99999] dark:bg-bg-dark-primary bg-bg-light-primary ">
      <div className="md:min-w-[60%] min-w-[80%]">
        <div className="flex flex-col items-center max-w-[90%] mx-auto px-4 py-8 text-center dark:bg-bg-dark-secondary bg-bg-light-secondary border dark:border-border-dark border-border-light shadow-glow md:px-14 md:py-16 lg:max-w-lg rounded-xl">
          <img
            src={logo}
            alt="Logo"
            className="flex items-center justify-center mb-6 rounded-full w-28 h-28 shadow-glow"

          />

          <>
            <h2 className="mb-2 text-2xl font-semibold text-black dark:text-white">
              {t("auth.welcome")}
            </h2>
            <h2 className="mb-2 text-2xl font-semibold text-black dark:text-white">{name}</h2>
            <p className="mb-6 text-gray-800 dark:text-gray-300">
              {t("auth.processing")}
            </p>

            <ProgressWithPercentage />
          </>

        </div>
      </div>
    </div>
  );
}
